async function switchToSubscription(bundleKey, planId) {
  const item = Rebuy.Cart.cart.items.find((item) => item.key == bundleKey);
  try {
    await Rebuy.Cart.switchToSubscription(item, planId);
  } catch (error) {
    console.error("Failed to parse bundleItem or call switchToSubscription:", error);
  } finally {
    setTimeout(() => {
      renderStarterKitLineItems();
    }, 2000);
  }
}

async function renderStarterKitLineItems() {
  const { items } = await fetchCart();
  const bundlesInCart = {};
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = document.querySelectorAll(".static-line-item-starter-kit");
  bundleLineItems.forEach((item) => item.remove());

  // Group items by _bundle_id
  items.forEach((item) => {
    const bundleId = item.properties["_bundle_id"];
    if (bundleId) {
      if (!bundlesInCart[bundleId]) {
        bundlesInCart[bundleId] = [];
      }
      bundlesInCart[bundleId].push(item);
    }
  });

  // Render each bundle
  Object.entries(bundlesInCart).forEach(([bundleId, bundleItems]) => {
    let newBundleLineItem = document.createElement(isCartPage ? "tr" : "li");
    newBundleLineItem.id = bundleId;
    newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-starter-kit");
    newBundleLineItem.dataset.type = "_bundle_id";

    if (isCartPage) {
      newBundleLineItem.innerHTML = starterKitLineItemMarkupCartPage(bundleItems);
    } else {
      newBundleLineItem.innerHTML = startKitBundleItemMarkup(bundleItems);
    }

    const addedBundleItem = document.getElementById(bundleId);
    if (!addedBundleItem) {
      cartPageItemsNode.append(newBundleLineItem);
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

function startKitBundleItemMarkup(bundleItems) {
  const fpTitle = bundleItems.find((item) => item.product_type === "Diffuser")?.product_title || "Bundle"; // Use the diffuser line item title
  const fpVariantTitle = bundleItems.find((item) => item.product_type === "Diffuser")?.variant_title;
  const fpSlashedOutPrice = bundleItems.reduce((sum, bundleItem) => {
    const compareAtPrice = parseFloat(bundleItem.properties?._compare_at_price) || bundleItem.original_price || 0;
    return sum + compareAtPrice;
  }, 0);

  const fpSalePrice = bundleItems.reduce((sum, bundleItem) => sum + bundleItem.final_price, 0);
  const fpOffValue = Math.round(((fpSlashedOutPrice - fpSalePrice) / fpSlashedOutPrice) * 100);
  const fpImg = bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")?.image || "";
  const fpUrl = bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")?.url || "";
  const bundleQty = bundleItems[0].quantity;

  function fpProductsTitleProp() {
    let string = "";

    bundleItems.forEach((bundleItem) => {
      if (bundleItem.product_type != "Diffuser") {
        string += `
        <div class="rebuy-cart__flyout-item-member">
          <div class="rebuy-cart__flyout-item-property">
            <span class="rebuy-cart__flyout-item-property-name">${bundleItem.product_type}</span>
            <span class="rebuy-cart__flyout-item-property-separator"> - </span>
            <span class="rebuy-cart__flyout-item-property-value">${bundleItem.title}</span>
            ${
              bundleItem.selling_plan_allocation
                ? `<p style="margin: 0;font-size: 12px;" class="rebuy-cart__flyout-item-property-value">${bundleItem.selling_plan_allocation.selling_plan.name}</p>`
                : `<button 
                    type="button" 
                    style="display: block;background: none; border: none; padding: 0; margin: 3px 0; text-decoration: underline; color: #000; font-size: 13px; cursor: pointer;" 
                    class="rebuy-cart__flyout-item-switch-button" 
                    onclick="switchToSubscription('${bundleItem.key}', '30 days')">
                    Upgrade to Subscribe & Save
                 </button>`
            }
          </div>
        </div>`;
      }
    });
    return string;
  }

  return `
          <div class="rebuy-cart__flyout-item-media">
            <a href="${fpUrl}" tabindex="-1">
              <img src="${fpImg}" alt="${fpTitle}">
            </a>
          </div>
          <div class="rebuy-cart__flyout-item-info">
            <a
              role="heading"
              aria-level="5"
              href="${fpUrl}"
              alt="View ${fpTitle}"
              class="rebuy-cart__flyout-item-product-title">${fpTitle}</a>
            <div class="rebuy-cart__flyout-item-variant-title">${fpVariantTitle}</div>
            ${fpOffValue > 0 ? `<div class="rebuy-cart__flyout-item-discount-message">Save ${fpOffValue}%</div>` : ``} 
            <div class="rebuy-cart__flyout-item-properties">
              ${fpProductsTitleProp()}
            </div>
            <button
              type="button"
              alt="Remove ${fpTitle}"
              aria-label="Remove ${fpTitle}"
              class="rebuy-cart__flyout-item-remove line-item__remove-button">
              <i aria-hidden="true" class="far fa-trash"></i>
            </button>
            <div class="rebuy-cart__flyout-item-quantity">
              <div class="rebuy-cart__flyout-item-quantity-widget">
                <button
                  alt="Decrease quantity of ${fpTitle}"
                  aria-label="Decrease quantity of ${fpTitle}"
                  type="button"
                  class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
                  <i aria-hidden="true" class="far fa-minus"></i>
                </button>
                <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
                  ${bundleQty}
                </span>
                <button
                  alt="Increase quantity of ${fpTitle}"
                  aria-label="Increase quantity of ${fpTitle}"
                  type="button"
                  class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
                  <i aria-hidden="true" class="far fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="rebuy-cart__flyout-item-price">
              <div>
                <span class="rebuy-money sale">
                  <span class="sr-only">Sale price</span>
                  <span>${formatMoney(fpSalePrice)}</span>
                </span>
                  ${
                  fpSlashedOutPrice && fpSlashedOutPrice != "0" && fpSlashedOutPrice > fpSalePrice
                    ? `
                  <span class="rebuy-money compare-at">
                  <span class="sr-only">Original price</span>
                  <span>${formatMoney(fpSlashedOutPrice)}</span>
                </span>
                  `
                    : ``
                }
              </div>
            </div>
          </div>
      `;
}

function starterKitLineItemMarkupCartPage(bundleItems) {
  const bundleTitle = bundleItems.find((item) => item.product_type === "Diffuser")?.product_title || "Bundle"; // Use the diffuser line item title
  const bundleVariantTitle = bundleItems.find((item) => item.product_type === "Diffuser")?.variant_title;
  const bundleSlashedOutPrice = bundleItems.reduce((sum, bundleItem) => {
    const compareAtPrice = parseFloat(bundleItem.properties?._compare_at_price) || bundleItem.original_price || 0;
    return sum + compareAtPrice;
  }, 0);

  const bundleSalePrice = bundleItems.reduce((sum, bundleItem) => sum + bundleItem.final_price, 0);
  const bundleOffValue = Math.round(((bundleSlashedOutPrice - bundleSalePrice) / bundleSlashedOutPrice) * 100);
  const bundleImg = bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")?.image || "";
  const bundleUrl = bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")?.url || "";
  const bundleQty = bundleItems[0].quantity;

  function bundleProductsTitleProp() {
    let string = "";
    bundleItems.forEach((bundleItem) => {
      if (bundleItem.product_type != "Diffuser") {
        string += `
        <div class="rebuy-cart__flyout-item-member">
          <div class="rebuy-cart__flyout-item-property">
            <span class="rebuy-cart__flyout-item-property-name">${bundleItem.product_type}</span>
            <span class="rebuy-cart__flyout-item-property-separator"> - </span>
            <span class="rebuy-cart__flyout-item-property-value">${bundleItem.title}</span>
             ${
               bundleItem.selling_plan_allocation
                 ? ` <p style="margin: 0;font-size: 12px;" class="rebuy-cart__flyout-item-property-value">${bundleItem.selling_plan_allocation.selling_plan.name}</p>`
                 : ""
             }
          </div>
        </div>`;
      }
    });
    return string;
  }

  return `
  <td>
    <line-item class="line-item">
      <img
        src="${bundleImg}"
        alt="${bundleTitle}"
        srcset="${bundleImg}?width=70 70w, ${bundleImg}?width=120 120w, ${bundleImg}?width=140 140w, ${bundleImg}?width=210 210w, ${bundleImg}?width=240 240w, ${bundleImg}?width=360 360w"
        width="1400"
        height="1700"
        loading="lazy"
        sizes="(max-width: 699px) 70px, 120px"
        class="line-item__media rounded-borders-top"
      >
      <div class="line-item-info">
        <div class="v-stack justify-items-start gap-2">
          <div class="v-stack justify-items-start gap-1">
            <a href="${bundleUrl}" class="">${bundleTitle}</a>
            <div class="rebuy-cart__flyout-item-variant-title">${bundleVariantTitle}</div>
            <price-list class="price-list">
              <sale-price class="text-subdued">
                <span class="sr-only">Sale price</span>${formatMoney(bundleSalePrice)}
              </sale-price>
            </price-list>
             <div class="rebuy-cart__flyout-item-properties">
              <span style="font-weight:500;">Bundle Products</span>
              ${bundleProductsTitleProp()}
             </div>
          </div>
          <div class="v-stack justify-items-start gap-1">
          
          </div>
          <line-item-quantity class="h-stack gap-4 sm:hidden">
            <quantity-selector class="quantity-selector quantity-selector--sm">
              <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
                <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
                  <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                </svg>
              </a>
              <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${bundleQty}</span>
              <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
                <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
                  <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                </svg>
              </a>
            </quantity-selector>
            <a href="javascript:void(0)" class="link text-xs line-item__remove-button">Remove</a>
          </line-item-quantity>
        </div>
      </div>
    </line-item>
  </td>

  <td class="text-center">
    <line-item-quantity class="v-stack justify-items-center gap-2">
      <quantity-selector class="quantity-selector quantity-selector--sm">
        <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
            <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${bundleQty}</span>
        <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
            <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
      </quantity-selector>
      <a href="javascript:void(0)" class="link text-xs line-item__remove-button">Remove</a>
    </line-item-quantity>
  </td>

  <td class="line-item__price-list-container text--right">
    <div class="price-list price-list--stack">
      <span class="price price--highlight">
        <span class="sr-only">Sale price</span>${formatMoney(bundleSalePrice)}
      </span>
      ${
        bundleSlashedOutPrice && bundleSlashedOutPrice != "0" && bundleSlashedOutPrice > bundleSalePrice
          ? ` <span class="price price--compare line-through text-subdued">
        <span class="sr-only">Regular price</span>${formatMoney(bundleSlashedOutPrice)}
      </span>` : `` }
    </div>
  </td>
   `;
}

// Bundles and Family Plan
async function renderBundleLineItems() {
  const { items } = await fetchCart();
  const bundlesInCart = [];
  let CartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = CartPageItemsNode.querySelectorAll(".static-line-item-bundle");
  bundleLineItems.forEach((item) => {
    item.remove();
  });
  items.map((item) => {
    const bundleCodeProp = item.properties["_bundle_hash"];
    if (bundleCodeProp) {
      if (!bundlesInCart.includes(bundleCodeProp)) {
        //run this block only for first item is the bundle
        bundlesInCart.push(bundleCodeProp);
        let newBundleLineItem = document.createElement("li");
        if (isCartPage) {
          newBundleLineItem = document.createElement("tr");
        }
        newBundleLineItem.id = bundleCodeProp;
        newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-bundle");
        if (isCartPage) {
          newBundleLineItem.innerHTML = bundleLineItemMarkupCartPage(item);
        } else {
          newBundleLineItem.innerHTML = bundleLineItemMarkup(item);
        }
        const addedBundleItem = document.getElementById(`${bundleCodeProp}`);
        if (!addedBundleItem) {
          CartPageItemsNode.append(newBundleLineItem);
        }
      }
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

async function renderFpLineItems() {
  const { items } = await fetchCart();
  const bundlesInCart = [];
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = cartPageItemsNode.querySelectorAll(".static-line-item-fp");
  bundleLineItems.forEach((item) => {
    item.remove();
  });
  items.map((item) => {
    const fpCodeProp = item.properties["_fp_id"];
    if (fpCodeProp) {
      if (!bundlesInCart.includes(fpCodeProp)) {
        bundlesInCart.push(fpCodeProp);
        let newBundleLineItem = document.createElement("li");
        if (isCartPage) {
          newBundleLineItem = document.createElement("tr");
        }
        newBundleLineItem.id = fpCodeProp;
        newBundleLineItem.classList.add("line-item", "rebuy-cart__flyout-item", "static-line-item", "static-line-item-fp");
        if (isCartPage) {
          newBundleLineItem.innerHTML = fpLineItemMarkupCartPage(item);
        } else {
          newBundleLineItem.innerHTML = fpLineItemMarkup(item);
        }
        const addedBundleItem = document.getElementById(`${fpCodeProp}`);
        if (!addedBundleItem) {
          cartPageItemsNode.append(newBundleLineItem);
        }
      }
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

function fpLineItemMarkupCartPage(item) {
  const fpTitle = "Family Plan";
  const fpSlashedOutPrice = item.properties["_fp_slashed_out_price"];
  const fpSalePrice = item.properties["_fp_sale_price"];
  let fpOffValue = item.properties["_fp_off_value"];
  const fpImg = item.properties["_fp_img"];
  const fpUrl = item.properties["_fp_url"];

  function fpProductsTitleProp(item) {
    let string = "";

    if (item.properties["_fq_products"]) {
      item.properties["_fq_products"].forEach((productGroup, index) => {
        string += `
			<div class="rebuy-cart__flyout-item-member">
			  <h4>Member ${index + 1}</h4>
			  <div class="rebuy-cart__flyout-item-property">
				<span class="rebuy-cart__flyout-item-property-name">Diffuser</span>
				<span class="rebuy-cart__flyout-item-property-separator"> - </span>
				<span class="rebuy-cart__flyout-item-property-value">${productGroup.product_title}</span>
			  </div>
			  <div class="rebuy-cart__flyout-item-property">
				<span class="rebuy-cart__flyout-item-property-name">Oil</span>
				<span class="rebuy-cart__flyout-item-property-separator"> - </span>
				<span class="rebuy-cart__flyout-item-property-value">${productGroup.addon_title}</span>
			  </div>
			</div>`;
      });
    }

    return string;
  }

  return `
		 <td class="line-item__product">
			 <div class="line-item__content-wrapper">
			 <a href="${fpUrl}" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">
			 <img class="line-item__image" loading="sizes" sizes="(max-width: 740px) 80px, 92px" height="1751" width="1400" alt="${fpTitle}" src="${fpImg}">
			 </a>
			 <div class="line-item__info">
				 <div class="product-item-meta">
				 <a href="${fpUrl}" class="product-item-meta__title text--small hidden-tablet-and-up">${fpTitle}</a>
				 <a href="${fpUrl}" class="product-item-meta__title hidden-phone">${fpTitle}</a>
 
				 <div class="product-item-meta__price-list-container">
					 <div class="price-list text--small hidden-tablet-and-up"><span class="price price--highlight">
					 <span class="visually-hidden">Sale price</span>${formatMoney(fpSalePrice)}</span><span class="price price--compare">
					 <span class="visually-hidden">Regular price</span>${formatMoney(fpSlashedOutPrice)}</span>
					 </div>
				 </div>
				 </div>
				 <ul class="line-item__discount-list list--unstyled" role="list">
				 <li class="line-item__discount-badge discount-badge">
					 <svg focusable="false" width="10" height="10" class="icon icon--discount-badge   " viewBox="0 0 10 10">
					 <path fill-rule="evenodd" clip-rule="evenodd" d="M9.93734 1.1171C9.97075 0.521457 9.47854 0.0292498 8.88291 0.0626607L5.39562 0.258271C5.15016 0.27204 4.91836 0.375751 4.74452 0.549595L0.707107 4.58701C0.316582 4.97753 0.316583 5.6107 0.707107 6.00122L3.99878 9.29289C4.3893 9.68342 5.02247 9.68342 5.41299 9.29289L9.4504 5.25548C9.62425 5.08163 9.72796 4.84984 9.74173 4.60438L9.93734 1.1171ZM7.05882 2.94118C7.3837 3.26605 7.91042 3.26605 8.23529 2.94118C8.56017 2.6163 8.56017 2.08958 8.23529 1.76471C7.91042 1.43983 7.3837 1.43983 7.05882 1.76471C6.73395 2.08958 6.73395 2.6163 7.05882 2.94118Z" fill="currentColor"></path>
					 </svg>
					 Family plan savings (-${formatMoney(fpOffValue)})
				 </li>
				 </ul>
				 <div class="rebuy-cart__flyout-item-properties">
				 ${fpProductsTitleProp(item)}
			   </div>
				 <line-item-quantity class="line-item__quantity hidden-tablet-and-up">
				 <div class="quantity-selector quantity-selector--small">
					 <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
					 <svg focusable="false" width="8" height="2" class="icon icon--minus   " viewBox="0 0 8 2">
						 <path fill="currentColor" d="M0 0h8v2H0z"></path>
					 </svg>
					 </a>
					 <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
             item.quantity
           }</span>
					 <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
					 <svg focusable="false" width="8" height="8" class="icon icon--plus   " viewBox="0 0 8 8">
						 <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5v3h2V5h3V3H5V0H3v3H0v2h3z" fill="currentColor"></path>
					 </svg>
					 </a>
				 </div>
				 <a href="javascript:void(0)" class="line-item__remove-button link text--subdued text--xxsmall hidden-tablet-and-up" data-no-instant="">Remove</a>
				 <a href="javascript:void(0)" class="line-item__remove-button link text--subdued text--xsmall hidden-phone" data-no-instant="">Remove</a>
				 </line-item-quantity>
			 </div>
			 </div>
		 </td>
		 <td class="line-item__quantity line-item__quantity--block text--center hidden-phone">
			 <line-item-quantity style="display: block; margin-top: -4px">
			 <div class="quantity-selector quantity-selector--small">
				 <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
				 <svg focusable="false" width="8" height="2" class="icon icon--minus   " viewBox="0 0 8 2">
					 <path fill="currentColor" d="M0 0h8v2H0z"></path>
				 </svg>
				 </a>
				 <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
           item.quantity
         }</span>
				 <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
				 <svg focusable="false" width="8" height="8" class="icon icon--plus   " viewBox="0 0 8 8">
					 <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5v3h2V5h3V3H5V0H3v3H0v2h3z" fill="currentColor"></path>
				 </svg>
				 </a>
			 </div>
			 <a href="javascript:void(0)" class="line-item__remove-button link text--subdued text--xxsmall hidden-tablet-and-up" data-no-instant="">Remove</a>
			 <a href="javascript:void(0)" class="line-item__remove-button link text--subdued text--xsmall hidden-phone" data-no-instant="">Remove</a>
			 </line-item-quantity>
		 </td>
		 <td class="line-item__price-list-container text--right hidden-phone">
			 <div class="price-list price-list--stack"><span class="price price--highlight">
			 <span class="visually-hidden">Sale price</span>${formatMoney(fpSalePrice)}</span><span class="price price--compare">
			 <span class="visually-hidden">Regular price</span>${formatMoney(fpSlashedOutPrice)}</span>
			 </div>
		 </td>
	`;
}

function fpLineItemMarkup(item) {
  const fpTitle = "Family Plan";
  const fpSlashedOutPrice = item.properties["_fp_slashed_out_price"];
  const fpSalePrice = item.properties["_fp_sale_price"];
  let fpOffValue = item.properties["_fp_off_value"];
  const fpImg = item.properties["_fp_img"];
  const fpUrl = item.properties["_fp_url"];

  function fpProductsTitleProp(item) {
    let string = "";

    if (item.properties["_fq_products"]) {
      item.properties["_fq_products"].forEach((productGroup, index) => {
        string += `
            <div class="rebuy-cart__flyout-item-member">
              <h4>Member ${index + 1}</h4>
              <div class="rebuy-cart__flyout-item-property">
                <span class="rebuy-cart__flyout-item-property-name">Diffuser</span>
                <span class="rebuy-cart__flyout-item-property-separator"> - </span>
                <span class="rebuy-cart__flyout-item-property-value">${productGroup.product_title}</span>
              </div>
              <div class="rebuy-cart__flyout-item-property">
                <span class="rebuy-cart__flyout-item-property-name">Oil</span>
                <span class="rebuy-cart__flyout-item-property-separator"> - </span>
                <span class="rebuy-cart__flyout-item-property-value">${productGroup.addon_title}</span>
              </div>
            </div>`;
      });
    }

    return string;
  }

  return `
        <div class="rebuy-cart__flyout-item-media">
          <a href="${fpUrl}" tabindex="-1">
            <img src="${fpImg} alt="${fpTitle}"></a>
        </div>
        <div class="rebuy-cart__flyout-item-info">
          <a
            role="heading"
            aria-level="5"
            href="${fpUrl}"
            alt="View ${fpTitle}"
            class="rebuy-cart__flyout-item-product-title">${fpTitle}</a>
          <div class="rebuy-cart__flyout-item-discount-message">Family plan savings ${formatMoney(fpOffValue)}</div>
          <div class="rebuy-cart__flyout-item-properties">
            ${fpProductsTitleProp(item)}
        </div>
          <!---->
          <button
            type="button"
            alt="Remove ${fpTitle}"
            aria-label="Remove ${fpTitle}"
            class="rebuy-cart__flyout-item-remove line-item__remove-button">
            <i aria-hidden="true" class="far fa-trash"></i>
          </button>
          <div class="rebuy-cart__flyout-item-quantity">
            <div class="rebuy-cart__flyout-item-quantity-widget">
              <button
                alt="Decrease quantity of ${fpTitle}"
                aria-label="Decrease quantity of ${fpTitle}"
                type="button"
                class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
                <i aria-hidden="true" class="far fa-minus"></i>
              </button>
              <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
                ${item.quantity}
              </span>
              <button
                alt="Increase quantity of ${fpTitle}"
                aria-label="Increase quantity of ${fpTitle}"
                type="button"
                class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
                <i aria-hidden="true" class="far fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="rebuy-cart__flyout-item-price">
            <div>
              <span class="rebuy-money sale">
                <span class="sr-only">Sale price</span>
                <span>${formatMoney(fpSalePrice)}</span>
              </span>
              <span class="rebuy-money compare-at">
                <span class="sr-only">Original price</span>
                <span>${formatMoney(fpSlashedOutPrice)}</span>
              </span>
            </div>
            <!---->
          </div>
          <!---->
        </div>
    `;
}

function bundleLineItemMarkupCartPage(item) {
  const bundleCodeProp = item.properties["_bundle_hash"];
  const bundleTitle = item.properties["_bundle_title"];
  const bundleSlashedOutPrice = item.properties["_bundle_slashed_out_price"];
  const bundleSalePrice = item.properties["_bundle_sale_price"];
  let bundleOffValue = item.properties["_bundle_off_value"];
  const bundleImg = item.properties["_bundle_img"];
  const bundleUrl = item.properties["_bundle_url"];
  if (bundleOffValue.includes("(")) {
    bundleOffValue = bundleOffValue.split("(")[1].split(")")[0].toUpperCase() + " Sale";
  }

  function bundleProductsTitleProp(item) {
    var string = "";
    for (const [key, value] of Object.entries(item.properties["_bundle_products"])) {
      const formattedKey = "Bundle " + key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
      if (key.includes("product") && value) {
        let propertyString = `
        <div class="rebuy-cart__flyout-item-property">
          <span class="rebuy-cart__flyout-item-property-value">${value}</span>
        </div>
        `;
        string = string.concat(propertyString);
      }
    }
    return string;
  }

  return `
  <td>
    <line-item class="line-item">
      <img
        src="${bundleImg}"
        alt="${bundleTitle}"
        srcset="${bundleImg}?width=70 70w, ${bundleImg}?width=120 120w, ${bundleImg}?width=140 140w, ${bundleImg}?width=210 210w, ${bundleImg}?width=240 240w, ${bundleImg}?width=360 360w"
        width="1400"
        height="1700"
        loading="lazy"
        sizes="(max-width: 699px) 70px, 120px"
        class="line-item__media rounded-borders-top"
      >
      <div class="line-item-info">
        <div class="v-stack justify-items-start gap-2">
          <div class="v-stack justify-items-start gap-1">
            <a href="${bundleUrl}" class="">${bundleTitle}</a>
            <price-list class="price-list">
              <sale-price class="text-subdued">
                <span class="sr-only">Sale price</span>${bundleSalePrice}
              </sale-price>
            </price-list>
             <div class="rebuy-cart__flyout-item-properties">
              <span style="font-weight:500;">Bundle Products</span>
              ${bundleProductsTitleProp(item)}
             </div>
          </div>
          <div class="v-stack justify-items-start gap-1">
          
          </div>
          <line-item-quantity class="h-stack gap-4 sm:hidden">
            <quantity-selector class="quantity-selector quantity-selector--sm">
              <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
                <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
                  <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                </svg>
              </a>
              <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
                item.quantity
              }</span>
              <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
                <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
                  <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
                </svg>
              </a>
            </quantity-selector>
            <a href="javascript:void(0)" class="link text-xs line-item__remove-button">Remove</a>
          </line-item-quantity>
        </div>
      </div>
    </line-item>
  </td>

  <td class="text-center">
    <line-item-quantity class="v-stack justify-items-center gap-2">
      <quantity-selector class="quantity-selector quantity-selector--sm">
        <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-dec" aria-label="Decrease quantity" data-no-instant="">
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-minus" viewBox="0 0 12 12">
            <path d="M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
        <span is="input-number" class="quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
          item.quantity
        }</span>
        <a href="javascript:void(0)" class="quantity-selector__button quantity-selector__button-inc" aria-label="Increase quantity" data-no-instant="">
          <svg aria-hidden="true" focusable="false" fill="none" width="10" class="icon icon-plus" viewBox="0 0 12 12">
            <path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1.5"></path>
          </svg>
        </a>
      </quantity-selector>
      <a href="javascript:void(0)" class="link text-xs line-item__remove-button">Remove</a>
    </line-item-quantity>
  </td>

  <td class="line-item__price-list-container text--right">
    <div class="price-list price-list--stack">
      <span class="price price--highlight">
        <span class="sr-only">Sale price</span>${bundleSalePrice}
      </span>
      <span class="price price--compare line-through text-subdued">
        <span class="sr-only">Regular price</span>${bundleSlashedOutPrice}
      </span>
    </div>
  </td>
   `;
}

function bundleLineItemMarkup(item) {
  const bundleCodeProp = item.properties["_bundle_hash"];
  const bundleTitle = item.properties["_bundle_title"];
  const bundleSlashedOutPrice = item.properties["_bundle_slashed_out_price"];
  const bundleSalePrice = item.properties["_bundle_sale_price"];
  let bundleOffValue = item.properties["_bundle_off_value"];
  const bundleImg = item.properties["_bundle_img"];
  const bundleUrl = item.properties["_bundle_url"];

  function bundleProductsTitleProp(item) {
    var string = "";
    for (const [key, value] of Object.entries(item.properties["_bundle_products"])) {
      const formattedKey = "Bundle " + key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, " ");
      if (key.includes("product") && value) {
        let propertyString = `
        <div class="rebuy-cart__flyout-item-property"><span class="rebuy-cart__flyout-item-property-name">${formattedKey}</span> <span class="rebuy-cart__flyout-item-property-separator">
          -
          </span> <span class="rebuy-cart__flyout-item-property-value">${value}</span>
        </div>
        `;
        string = string.concat(propertyString);
      }
    }
    return string;
  }

  return `
      <div class="rebuy-cart__flyout-item-media">
        <a href="${bundleUrl}" tabindex="-1">
          <img src="${bundleImg} alt="${bundleTitle}"></a>
      </div>
      <div class="rebuy-cart__flyout-item-info">
        <a
          role="heading"
          aria-level="5"
          href="${bundleUrl}"
          alt="View ${bundleTitle}"
          class="rebuy-cart__flyout-item-product-title">${bundleTitle}</a>
        <div class="rebuy-cart__flyout-item-discount-message">${bundleOffValue}</div>
        <div class="rebuy-cart__flyout-item-properties">
        ${bundleProductsTitleProp(item)}
      </div>
        <!---->
        <button
          type="button"
          alt="Remove ${bundleTitle}"
          aria-label="Remove ${bundleTitle}"
          class="rebuy-cart__flyout-item-remove line-item__remove-button">
          <i aria-hidden="true" class="far fa-trash"></i>
        </button>
        <div class="rebuy-cart__flyout-item-quantity">
          <div class="rebuy-cart__flyout-item-quantity-widget">
            <button
              alt="Decrease quantity of ${bundleTitle}"
              aria-label="Decrease quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
              <i aria-hidden="true" class="far fa-minus"></i>
            </button>
            <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
              ${item.quantity}
            </span>
            <button
              alt="Increase quantity of ${bundleTitle}"
              aria-label="Increase quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
              <i aria-hidden="true" class="far fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="rebuy-cart__flyout-item-price">
          <div>
            <span class="rebuy-money sale">
              <span class="sr-only">Sale price</span>
              <span>${bundleSalePrice}</span>
            </span>
            <span class="rebuy-money compare-at">
              <span class="sr-only">Original price</span>
              <span>${bundleSlashedOutPrice}</span>
            </span>
          </div>
          <!---->
        </div>
        <!---->
      </div>
  `;
}

async function getbundleProducts(bundleProp, bundleId) {
  const { items } = await fetchCart();
  let bundleProducts = [];
  items.map((item) => {
    if (item.properties[bundleProp] == bundleId) {
      bundleProducts.push(item);
    }
  });
  return bundleProducts;
}

function updateLineItemWithQty(bundleProducts, qty) {
  return new Promise((resolve, reject) => {
    if (!bundleProducts.length) return resolve(); // Resolve immediately if no products

    qty = parseInt(qty);
    const newObj = {};
    bundleProducts.forEach((item) => {
      newObj[item.key.toString()] = qty;
    });

    jQuery
      .post(window.Shopify.routes.root + "cart/update.js", {
        updates: newObj,
      })
      .done(() => {
        //updateCartSubtotal();
        resolve(); // Resolve when request is successful
      })
      .fail((error) => {
        console.log(error);
        reject(error); // Reject on error
      });
  });
}

async function attachELToLineItem() {
  let staticLineItems = document.querySelectorAll(".static-line-item");
  for (let i = 0; i < staticLineItems.length; i++) {
    const lineItem = staticLineItems[i];
    let removeBtns = lineItem.querySelectorAll(".line-item__remove-button");
    let qtyIncBtns = lineItem.querySelectorAll(".quantity-selector__button-inc");
    let qtyDecBtns = lineItem.querySelectorAll(".quantity-selector__button-dec");
    let qtyTexts = lineItem.querySelectorAll(".quantity-selector__input");
    let lineBundleId = lineItem.id;
    let bundleProp = lineItem.dataset.type;

    removeBtns.forEach((removeBtn) => {
      if (!removeBtn.hasAttribute("data-listener-attached")) {
        removeBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(bundleProp, lineBundleId);
          // console.log("click remove", event.target, bundleProp, lineBundleId, bundleProducts);
          try {
            await updateLineItemWithQty(bundleProducts, 0);
            lineItem.remove();
          } catch (error) {
            console.log("Error updating quantity:", error);
          }
        });
        removeBtn.setAttribute("data-listener-attached", "true");
      }
    });

    qtyIncBtns.forEach((qtyIncBtn) => {
      if (!qtyIncBtn.hasAttribute("data-listener-attached")) {
        qtyIncBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(bundleProp, lineBundleId);
          // console.log("click Inc", event.target, bundleProp, lineBundleId, bundleProducts);
          let qtyTextInt = parseInt(qtyTexts[0].innerText) + 1;

          try {
            await updateLineItemWithQty(bundleProducts, qtyTextInt);
            qtyTexts.forEach((qtyTxt) => {
              qtyTxt.innerText = qtyTextInt;
            });
          } catch (error) {
            console.log("Error updating quantity:", error);
          }
        });
        qtyIncBtn.setAttribute("data-listener-attached", "true");
      }
    });

    qtyDecBtns.forEach((qtyDecBtn) => {
      if (!qtyDecBtn.hasAttribute("data-listener-attached")) {
        qtyDecBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(bundleProp, lineBundleId);
          // console.log("click dec", event.target, bundleProp, lineBundleId, bundleProducts);
          let qtyTextInt = parseInt(qtyTexts[0].innerText) - 1;

          try {
            await updateLineItemWithQty(bundleProducts, qtyTextInt);
            if (qtyTextInt == 0) {
              lineItem.remove();
            } else {
              qtyTexts.forEach((qtyTxt) => {
                qtyTxt.innerText = qtyTextInt;
              });
            }
          } catch (error) {
            console.log("Error updating quantity:", error);
          }
        });
        qtyDecBtn.setAttribute("data-listener-attached", "true");
      }
    });
  }
}

document.addEventListener("rebuy:smartcart.show", (event) => {
  setTimeout(() => {
    const { items } = Rebuy.Cart.cart;
    if (items.some((item) => item.properties?.["_bundle_id"])) {
      renderStarterKitLineItems();
    }
  }, 2000);
});

const bundleATCBtn = document.querySelector(".bundle-add-to-cart__btn");
if (bundleATCBtn) {
  bundleATCBtn.addEventListener("click", function () {
    setTimeout(async () => {
      await renderBundleLineItems();
    }, 2000);
  });
}

if (isCartPage) {
  (async () => {
    const cart = await fetchCart();
    if (cart.items.some((item) => item.properties?.["_bundle_id"])) {
      await renderStarterKitLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_bundle_hash"])) {
      await renderBundleLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_fp_id"])) {
      await renderFpLineItems();
    }
  })();
} else {
  document.addEventListener("rebuy:smartcart.ready", async () => {
    const { items } = Rebuy.Cart.cart;
    if (items.length) {
      if (items.some((item) => item.properties?.["_bundle_id"])) {
        await renderStarterKitLineItems();
      }
      if (items.some((item) => item.properties?.["_bundle_hash"])) {
        await renderBundleLineItems();
      }
      if (items.some((item) => item.properties?.["_fp_id"])) {
        await renderFpLineItems();
      }
    }
  });
}
